// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".typographyButton--lyJpPcKh.ant-btn {\n    padding: 0;\n  }\n.typographyButton--lyJpPcKh .nextTypography--1dNTrgSD.ant-typography {\n      overflow-wrap: anywhere;\n      margin-bottom: 0;\n      width: 48px;\n      height: 30px;\n    }\n.typographyButton--lyJpPcKh .nextTypography--1dNTrgSD .ant-typography-copy {\n      padding: 4px 0 !important ;\n    }\n.typographyButton--lyJpPcKh .nextTypography--1dNTrgSD .ant-typography-copy {\n      width: 100%;\n      height: 100%;\n      margin-left: 0;\n    }\n.typographyButton--lyJpPcKh .nextTypography--1dNTrgSD > .text--1BM9hcxo {\n      cursor: pointer;\n    }\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"typographyButton": "typographyButton--lyJpPcKh",
	"nextTypography": "nextTypography--1dNTrgSD",
	"text": "text--1BM9hcxo"
};
export default ___CSS_LOADER_EXPORT___;
